import { usePaymentMethodSelectContext } from './PaymentMethodSelectContext';

import { isPayPalPaymentMethodValid } from './payPal/isPayPalPaymentMethodValid';

export function useIsPaymentMethodValid(): boolean {
    const { selectedPaymentMethod } = usePaymentMethodSelectContext();

    if (!selectedPaymentMethod) {
        return false;
    }

    switch (selectedPaymentMethod.paymentMethodType) {
        case 'PAYPAL_ACCOUNT':
            return isPayPalPaymentMethodValid(selectedPaymentMethod);
        default:
            return true;
    }
}
